import { MasonryComposableCardRenderer } from '@leagueplatform/masonry-renderers';

export const ErrorStateComposableCard: typeof MasonryComposableCardRenderer = (
  props,
) => (
  <MasonryComposableCardRenderer
    {...props}
    css={{
      borderColor: '$tagCriticalBorderBold',
    }}
  />
);
